/*!
 * Mobile Genome (Development Release)
 * Copyright 2014 NogginLabs, Inc.
 * Authored by: NogginLabs Programming Team
 */

define('modules/bookmark/api-lms',['require','marionette'],function(require) {
  'use strict';

  /////////////
  // IMPORTS /{
  /////////////

  var Marionette = require('marionette');

  /*****************************************************************************************************************///}

  var LMSStorage = Marionette.Controller.extend({

  ////////////////
  // PROPERTIES /{
  ////////////////

    lms: null,

  /*****************************************************************************************************************///}

  /////////////
  // METHODS /{
  /////////////

    initialize: function(options)
    {
      ////console.log('LMSStorage::initialize');
      console.warn('Bookmarking Solution: LMSStorage');

      this.lms = window.API_FRAME;
    },

  /*****************************************************************************************************************///}

  /////////
  // API /{
  /////////

    setComplete: function(options)
    {
      if (this.lms)
      {
        this.lms.SetReachedEnd();
        // this.lms.SetPassed();
      }
    },

    getLocation: function()
    {
      return (this.lms) ? this.lms.GetBookmark() : '{ }';
    },

    setLocation: function(value)
    {
      if (this.lms)
        this.lms.SetBookmark(value);
    },

    getDatachunk: function()
    {
      return (this.lms) ? this.lms.GetDataChunk() : '{ }';
    },

    setDatachunk: function(value)
    {
      if (this.lms)
        this.lms.SetDataChunk(value);
    },

    getStatus: function()
    {
      return (this.lms) ? parseInt(this.lms.GetStatus(), 10) : 4;
    },

    setStatus: function(value)
    {
      // this is a non-standard function
      if (value === 'completed' || value === 'passed')
        this.setComplete();
    },

    getScore: function()
    {
      return (this.lms) ? parseInt(this.lms.GetScore(), 10) : 0;
    },

    setScore: function(value)
    {
      if (this.lms)
        this.lms.SetScore(value, 100, 0);
    },

    getStudentName: function()
    {
      return (this.lms) ? this.lms.GetStudentName() : 'Name, Student';
    },

    getStudentID: function()
    {
      return (this.lms) ? this.lms.GetStudentID() : 'studentid';
    },

    getAttemptID: function()
    {
      var aID = Date.now().toString();
      if (this.lms)// && this.lms.GetAttemptID)
      {
        var trueAPI = this.lms.SCORM_GrabAPI();
        if (trueAPI && trueAPI.AttemptID)
          aID = trueAPI.AttemptID;
      }
      console.log('GET ATTEMPT ID:', aID);
      return aID;
    }

  /*****************************************************************************************************************///}

  });

  return LMSStorage;

});

